<template>
  <div style="display: flex; justify-content: space-between; background-color: rgb(233, 236, 246)">
    <!-- 选择字体 -->
    <v-dialog v-model="dialog" persistent>
      <div class="card" style="width: 100%;">
        <!-- 添加 overlay 用于加载状态 -->
        <v-overlay style="z-index: 11;" v-if="loading" absolute>
          <v-card style="background-color: white; padding: 20px; " outlined>
            <div style="color: black; " >{{ loadingText }}</div>
            <v-progress-linear
              color="primary"
              height="5"
              indeterminate
            ></v-progress-linear>
          </v-card>
        </v-overlay>
        <div
          style="width: 100%; padding-top: 10px; display: flex; justify-content: space-between;  align-items: center; position: sticky; top: 0;background-color: white; z-index: 10; ">
          <div style="flex-grow: 1; text-align: center; margin-right: -20px;">{{
            $i18n.t("ppt_add_in_main.template_select_shape_color") }}</div>

          <div style="display: flex; align-items: center;">
            <button style="margin-left: 5px;" @click="clickCloseSettings()">
              <v-icon>mdi-close</v-icon>
            </button>
          </div>
        </div>
        <v-list v-if="shape_colors.length > 0" :style="{ maxHeight: listMaxHeight + 'px' }">
          <v-list-item-group v-model="selectedItem" color="primary">
            <v-list-item v-for="(template, i) in shape_colors" :key="i">
              <v-list-item-icon>
                <img :src=template.cover alt=""
                  style="width: 50px; height: 50px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);" />
              </v-list-item-icon>
              <v-list-item-content style="margin-left: -22px; ">
                <div>{{ template.fileName }}</div>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>
    </v-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
// import { get, sync } from "vuex-pathify";
import { actionUniform } from "@/service/wd_pubsub_config.js";
import { subscribe, unsubscribe } from "@/service/wd_pubsub.js";
import { i18n } from "@/plugins/i18n.js";
import { wdConfigData } from "@/service/wd_app_config.js";
import { UniformShapeColor } from "@/views/gpt/util/gpt_addin_utils";
import aiMenusZh from "@/store/modules/aiMenus-zh";
import aiMenusEn from "@/store/modules/aiMenus-en";
//例如: import <组件名称> from  <组建路径>

export default {
    //import 引入的组件需要注入到对象中才能使用
  components: {},
  props: {},
  data() {
    //这里存放数据
    return {
      shape_colors:[],
      dialog: false,
      selectedItem: 0,
      loading: false,   
      loadingText: i18n.t('ppt_add_in_main.uniform_operation_loading_default')  
    };
  },
  //计算机属性 类似与data概念
  computed: {
    // ...get("gpt", ["shape_colors"]),
    // ...sync("gpt", ["shape_colors"]),

    listMaxHeight() {  
      return window.innerHeight - 160;  
    }
  },
  //监控data中数据变化
  watch: {
    selectedItem(newValue) {
      if (newValue >= 0) {
        UniformShapeColor(this.shape_colors[newValue].value)
      }
    } 
  },
  methods: {
    clickCloseSettings() {
      this.dialog = false
    },
    clickShowDialog() {
      this.dialog = true
    },
    updateListMaxHeight() {  
      this.$forceUpdate(); 
    },  
    // Pubsub
    pubCallback(msgName, data) {
      if (msgName == actionUniform.pubId_Action_Uniform_Color) {
        if (data.total === 0) {
          this.loading = false
          this.$message.warning(i18n.t('ppt_add_in_main.msg_something_error'))
        } else {
          if (data.current == 0) {
            this.loading = true
            this.loadingText = i18n.t('ppt_add_in_main.loading_txt_uniform_operation_begin')
          } else {
            this.loadingText = i18n.t('ppt_add_in_main.loading_txt_uniform_operation') +  data.current + ' / ' + data.total
          }
          if (data.current === data.total-1) {
            this.loading = false
          }
        }
      } 
    },
  },
  beforeDestroy() {
    window.addEventListener('resize', this.updateListMaxHeight); 
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {},
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {
    i18n.locale = wdConfigData.localLanguage
    if (i18n.locale == "zhHans") {
      this.shape_colors = aiMenusZh.state.shape_colors
    } else {
      this.shape_colors = aiMenusEn.state.shape_colors
    }
    subscribe(actionUniform.pubId_Action_Uniform_Color, this.pubCallback)
    window.addEventListener('resize', this.updateListMaxHeight)
  },
  destroyed() { 
    unsubscribe(this.pubCallback)
  }, //生命周期-销毁完成
  activated() { }, //如果页面有keep-alive,这函数会触发
}
</script>